import React from 'react';
import spiritual from '../../assests/img/spiritual.jpg';

const SpiritualCareAndWellbeing = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Spiritual Care and Wellbeing</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Spiritual care and Wellbeing
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p>
                                                    <img style={{ paddingLeft: "15px", float: "right" }} src={spiritual} alt="spiritual" width="293" height="305" />
                                                    Our civilisational heritage of “guru-shishya parampara” is at the heart of Karamchand Memorial School. Pupils need to be happy and confident to enjoy life at school and to do their best, which is why we put such emphasis on care of the highest quality. We‘ll listen to pupils, valuing their opinions and respecting their feelings. We strongly believe that children who feel safe, happy and respected are best placed to learn and to develop into strong and confident adults.
                                                </p>
                                                <p style={{ textAlign: 'justify' }}>
                                                    The safeguarding of our pupils is paramount and underpins everything we do. We at KCMS believe that it’s not about having someone to look after you; it’s about having people to look out for you, and there’s a world of difference. Learners of all types and from all backgrounds will be looked after by a team of enthusiastic, talented and caring staff. We have a firm belief that our pupils will flourish under the individual attention we’ll offer at KCMS, thus forming close bonds with their fellow pupils, staff and their tutors who’ll guide them through all aspects of daily life.
                                                </p>
                                                <p style={{ textAlign: 'justify' }}>
                                                    We’ll nurture our pupils emotional development, and encourage them to support each other, through our school’s six core values. These are: Kindness & Mutual Respect, Curiosity, Integrity, Perseverance, Truth and Humility. These and related values will regularly feature in school assemblies, newsletters and in displays around school. They’ll provide focal points for discussions around character traits we aim to foster in all our pupils.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default SpiritualCareAndWellbeing;